import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const select = async (data: any) => {
  return httpRequest.get(`/api/collection/staff/select`, data);
};
